<template>
    <div class='box'>

        <phoneCarousel :list="webDate.phoneCooperationBanner" height="16.25rem" v-if="webDate"></phoneCarousel>
        <div class="cooper">

            <pageTitle title="品牌授权" subtitle="Brand authorization" titleFontSize="2.43rem" subtitleFontSize="1.22rem">
            </pageTitle>

            <div class="table">
                <!-- <el-table :data="tableData" style="height: 17.76rem;" stripe :row-class-name="tableRowClassName">
                    <el-table-column prop="no" label="授权编号" width="280" align="center" />
                    <el-table-column prop="name" label="客户名称" width="280" align="center" />
                    <el-table-column prop="area" label="授权区域" align="center" />
                    <el-table-column prop="expireDate" label="授权有限期" align="center" />
                </el-table> -->
                <el-form :inline="true" label-width="75px">
                    <el-form-item label="授权编号:">
                        <el-input v-model="queryParams.no" clearable class="searchsize" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称:">
                        <el-input v-model="queryParams.name" clearable class="searchsize" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="授权区域:">
                        <el-input v-model="queryParams.area" clearable class="searchsize" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="授权等级:">
                        <el-select v-model="queryParams.level" clearable placeholder="请选择">
                            <el-option label="区域代理商" value="区域代理商"></el-option>
                            <el-option label="授权使用商" value="授权使用商"></el-option>
                            <el-option label="特许生产工厂" value="特许生产工厂"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="changeQuery()">查询</el-button>
                    </el-form-item>
                </el-form>
                <div class="table_boxs">
                    <table class="table_box">
                        <thead>
                            <tr>
                                <th>授权编号</th>
                                <th>客户名称</th>
                                <th>授权区域</th>
                                <th>授权有限期</th>
                                <!-- <th>授权等级</th>
                                <th>是否特殊工厂</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in tableData" :key="index">
                                <td>{{ item.no }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.area }}</td>
                                <td>{{ item.expireDate }}</td>
                                <!-- <td>{{ item.level }}</td>
                                <td>{{ item.factory }}</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pagination_box">
                    <pagination :total="total" v-model:pageNum='queryParams.pageNum' :pagerCount='5' v-model:pageSize='queryParams.pageSize' @currentChange='getList'></pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import pageTitle from '@/components/pageTitle.vue'
import pagination from '@/components/pagination.vue'
import phoneCarousel from "@/components/phoneCarousel.vue"
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { getTablePage } from '@/api/Cooperation/index.js'

const store = useStore()
const webDate = computed(() => store.state.webDate);

const queryParams = ref({
    pageNumber: 1,
    pageSize: 10,
    no: null,
    name: null,
    area: null,
    level: null,
})
const total = ref(0);
const tableData = ref([]);
const getList = () => {
    getTablePage(queryParams.value).then(res => {
        if (res.code == 0) {
            tableData.value = res.data;
            total.value = res.total;
        }
    })
}
getList();


const changeQuery = () => {
    queryParams.value.pageNum = 1;
    getList();
}

const tableRowClassName = ({ row, rowIndex, }) => {
    if (rowIndex === 1) {
        return 'warning-row'
    } else if (rowIndex === 3) {
        return 'success-row'
    }
    return ''
}
</script>

<style scoped lang='scss'>
.box {
    padding-top: 6.25rem;
}

.cooper {
    padding: 3.75rem 1.56rem 2.19rem;

    .table {
        margin-top: 2.25rem;

        .table_boxs {
            min-height: 48.18rem;
            overflow-x: scroll;
        }

        .table_box {
            width: 100%;
            border-collapse: collapse;

            thead {
                tr {
                    background: #024d74;
                    height: 4.38rem;
                }

                th {
                    font-size: 1.38rem;
                    color: #ffffff;
                }
            }

            tbody {
                tr {
                    height: 4.38rem;
                    font-size: 1.38rem;
                    color: #000000;
                    border-bottom: 1px solid #ededed;
                    border-left: 1px solid #ededed;
                    border-right: 1px solid #ededed;

                    td {
                        text-align: center;
                        vertical-align: middle;
                    }

                    &:nth-child(2n) {
                        background: #f5f5f5;
                    }
                }
            }
        }
    }
}

.pagination_box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 2rem 0;
}
</style>